export default __webpack_public_path__ + "src/envmap/scaled/py.jpg";